// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"av","arrowBtnBox":"av","arrow-btn-wrap-box":"aw","arrowBtnWrapBox":"aw","arrow-btn-text":"ax","arrowBtnText":"ax","arrow-btn-arrow":"ay","arrowBtnArrow":"ay"};